
import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import UploadedFileName from 'components/UploadFileName'
import { Ptag, OverlayLoader, LargeButton, PageTitle, SimpleDateField } from '../components/core'
import download from "assets/svgs/downloadNew.svg";
import upload from  "assets/svgs/uploadFile.svg";
import http from '../services/httpService'
import config from '../config.json'
import axios from 'axios'
import { useNavigate, useParams } from "react-router-dom";
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import routes from "../components/routes";
import { formatDate, formatToRupees, rupeesToNumber } from 'utlis/utils'
import { useRecoilState} from "recoil";
import { completedDocumentUpload } from 'state/planSetup'
import { FLEX_PRODUCTS } from 'constants';
import UploadFile from 'components/UploadFile';
import NewDateField from 'components/core/NewDateField';
import moment from 'moment';

const planKeyName = {
   "Group Health Insurance":  'GMC' ,
   "Group Personal Accident":  'GPA' ,
   "Group Term Life":  'GTL'
}

const FileFormat = {
    "Group Health Insurance": 'https://getvitalimages.s3.ap-south-1.amazonaws.com/images/First%2BTime%2BUpload%2BGHI%2BNew%2Bformat_2.xlsx',
    "Group Personal Accident": 'https://getvitalimages.s3.ap-south-1.amazonaws.com/images/First+time+upload+GPA.xlsx',
    "Group Term Life": 'https://getvitalimages.s3.ap-south-1.amazonaws.com/images/First+Time+Upload+GTL.xlsx'
}

const UploadDocument = () => {
    const navigate = useNavigate();
    const {type} = useParams()
    const [loading, setLoading] = useState(false)
    const [uploadErrorData, setUploadErrorData] = useState([])
    const [excelName, setExcelName] = useState('')
    const [ excelFile, setExcelFile] = useState({name:'', size:''})
    const [invoiceName, setInvoiceName] = useState('')
    const [ invoiceFile, setInvoiceFile] = useState({name:'', size:''})
    const [amount, setAmount] = useState('')
    const [empExcelId, setEmpExcelId] = useState()
    const [invoiceId, setInvoiceId] = useState()
    const [paymentdate, setPaymentDate] = useState()
    const [employeewiseSheet, setEmployeewiseSheet] = useState()
    const [invoiceNameError, setInvoiceNameError] = useState("*Please upload invoice")
    const [excelNameError, setExcelNameError] = useState("*Please upload employee excel")
    const [amountError, setAmountError] = useState('*required')
    const [dateError, setDateError] = useState('')
    const [showError, setShowError] = useState(false)
    const [isShow, setIsShow] = useState()
    const ref = useRef()
    const header = localStorage.getItem('mark_index')
    const selectedPlan = JSON.parse(localStorage.getItem('selected_plan_document'))
    const uploadedPlan = JSON.parse(localStorage.getItem('uploaded_plan_document')) || []
    const [completedPlan, setCompletedPlan] = useRecoilState(completedDocumentUpload);
    const reupload = type === 'reupload'?true: false
    const renderError = (error, style) => {
       
        return (
          <Error style={style}>
            {error}
          </Error>
        )
    }
    const handleDateChange = (value) => {
        let newDate = value
        if(!paymentdate){
            setPaymentDate(newDate)
            return
        }
        let prevDateLen = paymentdate.length
        let newDateLen = value.length
        let newDob = newDate

        if (newDateLen < prevDateLen) {
            newDob = paymentdate.substr(0, prevDateLen - 1)
        } else if (newDateLen <= 10) {
            if (newDateLen === 2 || newDateLen === 5) {
                newDob = newDate + '/'
            }
        } else {
            newDob = newDate.slice(0, 10)
        }
        setPaymentDate(newDob)
    }


    const onUploadPremiumInvoice = async (oEvent) => {
        if (!oEvent?.target?.files[0]) {
            return
        } else if(oEvent?.target?.files[0].type !== "application/pdf") {
            alert("Please upload file in correct format");
            return;
        }
    
        let formData = new FormData()
        formData.append('file_details', oEvent.target.files[0])
    
        try {
            formData.append('file_owner', localStorage.getItem('id'))
            formData.append('userplan_id', localStorage.getItem('userplan_id'))
            formData.append('file_type', 'premiums_invoice')
            const { data } = await axios({

              url: config.apiUrl + '/insurance/upload_document/',
              method: 'POST',
              data: formData,
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'multipart/form-data',
              }

            })
            data.id && setInvoiceId(data.id)
            setInvoiceName(oEvent.target.files[0]['name'])
            setInvoiceFile({name:oEvent.target.files[0]['name'], size: oEvent.target.files[0].size})
            oEvent.target.value = null
        } catch (ex) {
          oEvent.target.value = null
          alert("Invalid file! Please enter correct file")
        }
        // setLoading(false)
    }

    const onUpload = async (oEvent) => {
        const supportedFormats = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
        if (!oEvent?.target?.files[0]) {
            return
        } else if (!supportedFormats.includes(oEvent?.target?.files[0].type)) {
            alert("Please upload file in correct format");
            return;
        }
        setUploadErrorData([])
        let formData = new FormData()
        formData.append('file_details', oEvent.target.files[0])

        try {
            // setLoading(true)
            formData.append('file_owner',localStorage.getItem('id'))
            formData.append('file_type', 'employees_excel')
            const { data } = await axios({

                url: config.apiUrl + '/insurance/upload_document/',
                method: 'POST',
                data: formData,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                }

            })

            data.id && setEmpExcelId(data.id)
            setExcelName(oEvent.target.files[0]['name'])
            setExcelFile({name: oEvent.target.files[0]['name'], size: oEvent.target.files[0].size})
            oEvent.target.value = null
        } catch (ex) {

            oEvent.target.value = null
            // setLoading(false)
        }

    }
    const DownloadExcel = () => {
        let url = FileFormat[header] || ''
        window.open(url, true)
    }

    const navigateToNextPage = () => {
        // if(selectedPlan.length == 1){
        //     localStorage.removeItem('uploaded_plan_document')
        //     localStorage.removeItem('selected_plan_document')
        //     navigate(`/${routes.CARE_DASHBOARD}`); 
        // } else {
        //     navigate(`/${routes.SELECT_PLAN}`); 
        // }
        navigate(`/${routes.SELECT_PLAN}`); 
       
    }
    console.log({employeewiseSheet})
    const handleSubmit = async () =>{
        setShowError(false)
        const isValid = moment(paymentdate, "YYYY-MM-DD", true).isValid()
        const isFuture = moment(paymentdate, "YYYY-MM-DD").isAfter();
        if (!invoiceName || !excelName || !amount || !isValid || isFuture) {
        if(!isValid || isFuture)setDateError('*Enter a valid date')
        setShowError(true)
        setIsShow('true')
        return
        }
        const flexProduct = localStorage.getItem('is_product_flex')
        var businessType = ''
        if(flexProduct == 1){
            for(const key in FLEX_PRODUCTS){
                if(FLEX_PRODUCTS[key] === header){
                    businessType = key
                }
            }
            console.log(businessType)
        }else {
            businessType = planKeyName[header]
        }
        setCompletedPlan([...completedPlan, header])

        setLoading(true)
        // if(businessType === 'GMC'){
        //     businessType = localStorage.getItem('gmc_business_type')
        // }

        try{
            await http.post('/business/upload_employee_issuance_data/',
            {
                document_id: empExcelId,
                business_type: businessType,
                invoice_id: invoiceId,
                payment_date: formatDate(paymentdate),
                amount: rupeesToNumber(amount),
                reupload_required: reupload,
                invoice_employee_wise_breakup_sheet_id:employeewiseSheet
            })
            const reducedSelectedPlan = selectedPlan.filter(element => element!=header)
            const reducedUploadedPlan = uploadedPlan.filter(element => element[0]!=header)
            console.log(reducedUploadedPlan)
            reducedUploadedPlan.push([header, excelName, invoiceName])
            localStorage.setItem('selected_plan_document', JSON.stringify(reducedSelectedPlan))
            localStorage.setItem('uploaded_plan_document', JSON.stringify(reducedUploadedPlan))
            // setSelectedIndices()
            navigateToNextPage()
        }catch(ex){
            console.log({ex})
            if(ex?.response?.status === 500) {
                alert("Some error has occured!")
            } else if(ex?.response?.status === 400) {
                setUploadErrorData(ex.response && Array.isArray(ex.response.data) && ex.response.data || [])
            }
             else {
                const reducedSelectedPlan = selectedPlan.filter(element => element!=header)
                const reducedUploadedPlan = uploadedPlan.filter(element => element[0]!=header)
                reducedUploadedPlan.push([header, excelName, invoiceName])
                localStorage.setItem('selected_plan_document', JSON.stringify(reducedSelectedPlan))
                localStorage.setItem('uploaded_plan_document', JSON.stringify(reducedUploadedPlan))
                // setSelectedIndices()
                navigateToNextPage()
            }
            setLoading(false)
            return
        }
    }

    const getTitle = (product) => {
        if(product === "GMC") return "GHI";
        return product
    }
    const handleAmountChange = (event) => {
        const modifiedAmouunt = formatToRupees(event.target.value)
        setAmount(modifiedAmouunt)
    }


    return (
        <>
            <SideNav>
                {
                    type !== 'onboarding' && type !== 'reupload' &&
                    <SideNavContent />
                }
                
            </SideNav>
        

            <HomeWrapper>
                
                {loading && <OverlayLoader />}

                <Body>
                    <PageTitle title={`Upload Data For ${header}`} />
                    <div style={{'display': 'flex', 'flexDirection': 'row', 'justifyContent': 'space-between', 'alignItems': 'center', 'marginTop': '20px'}}>
                        <Ptag   
                            fontSize="22px"
                            fontWeight="600"
                            letterHeight="1.33"
                            letterSpacing="0px"
                            style={{'paddingBottom':'0px'}}>
                        {'Employee Information'}
                        </Ptag>
                        <DownloadButton id="business_uploadexcel_download_button" onClick={() => DownloadExcel()}>
                            <img style={{ 'marginRight': '6px', 'height': '20px', 'width': '17px' }} src={download} />
                            <Ptag color='white' textAlign='center' fontSize='14px' fontWeight='600' letterSpacing='0px' letterHeight='19px'>
                                {'Download Excel Format'}
                            </Ptag>
                        </DownloadButton>
                    </div>

                    <UploadButton id="business_uploadexcel_upload_button" onClick={() => document.getElementById('fileSelect').click()} >
                        <img style={{ marginRight: "6px", height: "16px", width : "14px" }} src={upload} height='20px' width='17px' />
                        <input
                            name='upload'
                            id="fileSelect"
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={(oEvent) => onUpload(oEvent)}
                        />
                        <Ptag fontSize='14px' fontWeight='600' letterHeight='19px'>
                            {'Upload file'}
                        </Ptag>
                    </UploadButton>
                    {isShow && !excelName && renderError(excelNameError,{position: 'inherit', marginTop: '1.2rem'})}
                    {excelName && <UploadedFileName file={excelFile} onClick={() => setExcelName('')}/>} 

                </Body>
                {!!uploadErrorData.length &&
                    <ErrorTag>
                        <Ptag color='#F27576' style={{paddingBottom : '36px', height : '19px', fontSize : '14px', fontWeight : '700'}}>Errors!</Ptag>
                        <div>
                        <table border='0.4px' frame='void' rules='all' style={{width : '100%'}}>
                            <thead>
                                <tr>
                                    <TableData><Ptag style={{height : '10px', fontWeight :'600', textAlign : 'center'}}>ROW</Ptag></TableData>
                                    <TableData><Ptag style={{height : '10px', fontWeight :'600',  textAlign : 'center'}}>COLUMN</Ptag></TableData>
                                    <TableData><Ptag style={{paddingLeft : '3px', width : '24px', height : '14px', fontWeight :'600'}}>MESSAGE</Ptag></TableData>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            uploadErrorData.map( (error, index) => 
                                <tr>
                                    <TableData><Ptag textAlign = 'center' style={{fontSize : '12px', fontWeight :'500'}}>{error?.Row_number || ''}</Ptag></TableData>
                                    <TableData><Ptag textAlign = 'center' style={{fontSize : '12px', fontWeight :'500'}}>{error?.column || ''}  {'  '}</Ptag></TableData>
                                    <TableData><Ptag style={{fontSize : '12px', fontWeight :'600'}}>{error?.error || ''}</Ptag></TableData>
                                </tr>
                            )}    
                            </tbody>
                        </table>
                        </div>
                    </ErrorTag>
                }

                <Body>
                    <hr></hr>
                    <Ptag       
                        fontSize="22px"
                        fontWeight="600"
                        letterHeight="1.33"
                        letterSpacing="0px"
                        style={{'paddingBottom':'0px','paddingTop':'40px'}}>
                    {'Premium Invoice'}
                    </Ptag>

                    <UploadButton id="business_uploadPolicyDoc_upload_button" onClick={() => document.getElementById('fileSelectpdf').click()} >
                        <img style={{ marginRight: "6px", height: "16px", width : "14px" }} src={upload} height='20px' width='17px' />
                        <input
                            name='upload'
                            id="fileSelectpdf"
                            type="file"
                            accept="application/pdf"
                            onChange = {(oEvent) => onUploadPremiumInvoice(oEvent)}
                        />
                        <Ptag fontSize='14px' fontWeight='600' letterHeight='19px'>
                            {'Upload Document'}
                        </Ptag>
                        
                    </UploadButton>
                    {isShow && !invoiceName && renderError(invoiceNameError,{position: 'inherit', marginTop: '1.2rem'})}
                    {invoiceName && <UploadedFileName file={invoiceFile} onClick={() => setInvoiceName('')}/>}

                    <AmountDiv>
                        <ColumnFlex>
                            <InputField>
                                <input style={{'border':'0', "outline":"none","height":"auto","width":"100%","fontSize":"medium","paddingLeft":"18px"}}
                                    type="text"  
                                    value={amount}
                                    placeholder="Premium Amount"  
                                    onChange={handleAmountChange}
                                    required
                                />
                            </InputField>
                            {isShow && !amount && renderError(amountError, {position: 'inherit', marginTop: '1.2rem'})}
                        </ColumnFlex>
                            <ColumnFlex>
                                {/* <SimpleDateField
                                    value={paymentdate}
                                    placeholder="Date of Payment (DD/MM/YYYY)"  
                                    // error={"Enter a valid Date"}
                                    onChange={(e) => handleDateChange(e.target.value)}
                                    required
                                    >
                                </SimpleDateField> */}
                                <NewDateField
                                defaultValue={paymentdate}
                                error={dateError}
                                setDate={(value)=>setPaymentDate(value)}/>
                                {/* {isShow && (!paymentdate || showError) && renderError(dateError, {position: 'inherit', marginTop: '1.2rem'})} */}
                            </ColumnFlex>
                    </AmountDiv>
                    <UploadFile
                        label="Employee-wise Break-up"
                        text="Upload Document"
                        format="excel"
                        type="employee_wise_breakup"
                        onSelect={setEmployeewiseSheet}
                        bottom="-5rem"
                    />
                </Body>
                <Body>
                <ButtonWrapper>
                    <LargeButton
                    id="business_about_next12"
                    label="Save & Next"
                    type="submit"
                    onClick={handleSubmit}
                    />
                </ButtonWrapper>
                </Body>

            </HomeWrapper>
        </>
    )
}
const ColumnFlex = styled.div`
    display: flex;
    flex-direction: column;
`

const AmountDiv = styled.div`
    display: flex;
    flex-direction: row;
`
const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-top:20px;
`;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`

const InputField = styled.div`
    display: flex;
    width: 341px;
    margin-top: 24px;
    border: 1px solid #436AB2;
    border-radius: 6px;
    padding: 5px;
    justify-content: left;
    cursor: pointer;
    height: 50px;
    margin-right: 20px;
    /* & > input{
        display: none;
    }   */
`

const Body = styled.div`
    max-width: 800px;
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 1;
`

const DownloadButton = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    /* border: 1px solid #436AB2; */
    border-radius: 10px;
    background-color: ${props => props.theme.accentColor};
    /* margin-top: 24px; */
    padding: 20px;
    cursor: pointer;
    max-width: 40%;
    height: 36px;
`

const UploadButton = styled.div`
    display: flex;
    margin-top: 24px;
    border: 1px solid #E4E4E4;
    box-shadow: 0px 0px 6px rgba(74, 74, 74, 0.19);
    border-radius: 10px;
    padding: 48px;
    justify-content: center;
    cursor: pointer;
    & > input{
        display: none;
    }  
`
const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  padding-bottom: 50px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  margin-left: 200px;
`

const ErrorTag = styled.div`
  padding: 24px;
  background-color: #F8F8F8;
  border-radius: 10px;
  margin-bottom: 10px;
`

const TableData = styled.td`
    padding: 10px;

`

export default UploadDocument